
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Weather',
  // Mis propiedades
  props: {
    city: String,
    weatherSummary: String,
    weatherDescription: String,
    currentTemperature: Number,
    lowTemperature: Number,
    highTemperature: Number,
  },
  // Mis métodos
  methods: {
    // Lanza el evento de limpiar los datos del tiempo
    clearWeather() {
      this.$emit('clear-weather-data');
    },
  },
});
